module.exports = __webpack_public_path__ + "img/warnings-03.428408b5.png";